












































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { Family } from '@/interfaces/Models';
import { Debounce } from 'lodash-decorators';
import { Action, Getter } from 'vuex-class';
import NotificationFormDialog from '@/components/dashboard/shared/components/Notification/NotificationFormDialog.vue';

@Component({
  components: {
    NotificationFormDialog,
  },
})
export default class FamilyTable extends Vue {
  public selected = [];
  public showSelect = false;
  public showNotificationDialog = false;

  public familyData: Family = {
    id: 0,
    family_name: '',
    parent: {
      id: 0,
      first_name: '',
      last_name: '',
      contact: '',
    },
    babysittingLanguage: null,
    additional_info: '',
    address: {
      id: 0,
      address: '',
      area_name: '',
      city: '',
      district: '',
      postal_code: '',
      geo_location: '',
      created_at: '',
      updated_at: '',
    },
    contact: '',
    balance: {
      id: 0,
      formatted_balance: '',
      hours: 0,
    },
    package: {
      id: 0,
      name: '',
      cost: 0,
      price_per_hours: 0,
    },
    latest: {
      updated_at: '',
    },
    created_at: '',
    updated_at: '',
  };

  public dialog = false;

  get headersLocalized(): any[] {
    return [
      {
        text: this.$t('table_headers.families.family_name'),
        value: 'family_name',
      },
      {
        text: this.$t('table_headers.families.contact'),
        value: 'parent.contact',
      },
      {
        text: this.$t('table_headers.families.babysittingLanguage'),
        value: 'babysittingLanguage.name',
      },
      //   {
      //     text: this.$t(
      //       'families.edit.babysitting_preferences.covid_vaccine.title'
      //     ),
      //     value: 'babysittingPreferences.covid_vaccinated',
      //   },
      {
        text: this.$t('table_headers.sessions.city'),
        value: 'address.city.name',
      },
      {
        text: this.$t('table_headers.families.address'),
        value: 'address.address',
      },
      {
        text: this.$t('table_headers.families.balance'),
        value: 'balance.formatted_balance',
      },
      {
        text: this.$t('table_headers.families.balance_plan'),
        value: 'package.name',
      },
      {
        text: this.$t('table_headers.families.package_expiry_date'),
        value: 'package_expiry_date',
      },
      {
        text: this.$t('table_headers.shared.actions'),
        value: 'actions',
        align: 'end',
      },
    ];
  }
  public plans = [
    {
      id: 6,
      name: 'pay as you go',
    },
    {
      id: 7,
      name: 'bronze',
    },
    {
      id: 8,
      name: 'silver',
    },
    {
      id: 9,
      name: 'gold',
    },
    {
      id: 10,
      name: 'platinum',
    },
  ];

  public getPlanName(item: { name: string }): string {
    return this.$t(`packages.${item.name}.name`) as string;
  }

  public showDialog() {
    this.showNotificationDialog = true;
  }

  public toggleSelect() {
    this.showSelect = !this.showSelect;
    if (!this.showSelect) {
      this.selected = [];
    }
  }

  @Watch('family')
  @Watch('paymentPlan')
  @Watch('hasNegativeBalance')
  @Watch('withDeactivated')
  @Watch('isPotentialFamily')
  @Watch('city')
  @Watch('itemsPerPage')
  @Debounce(500)
  onFilterValueChange() {
    this.currentPage = 1;
    this.fetchFamilies();
  }

  @Watch('currentPage')
  onPageChange() {
    if (this.$vuetify.breakpoint.mobile) {
      this.$vuetify.goTo(0);
    }
    this.fetchFamilies();
  }

  @Action('families/setFamily') setFamily: any;
  @Getter('families/family') familyState: any;
  public get family(): string {
    return this.familyState;
  }

  public set family(family: string) {
    console.log('family');
    this.setFamily(family);
  }

  @Action('families/setPaymentPlan') setPaymentPlan: any;
  @Getter('families/paymentPlan') paymentPlanState: any;
  public get paymentPlan(): string {
    return this.paymentPlanState;
  }

  public set paymentPlan(paymentPlan: string) {
    this.setPaymentPlan(paymentPlan);
  }

  @Action('families/setIsPotentialFamily') setIsPotentialFamily: any;
  @Getter('families/isPotentialFamily') isPotentialFamilyState: any;
  public get isPotentialFamily(): string {
    return this.isPotentialFamilyState;
  }

  public set isPotentialFamily(isPotentialFamily: string) {
    this.setIsPotentialFamily(isPotentialFamily);
  }

  @Action('families/setHasNegativeBalance') setHasNegativeBalance: any;
  @Getter('families/hasNegativeBalance') hasNegativeBalanceState: any;
  public get hasNegativeBalance(): string {
    return this.hasNegativeBalanceState;
  }

  public set hasNegativeBalance(hasNegativeBalance: string) {
    this.setHasNegativeBalance(hasNegativeBalance);
  }

  @Action('families/setWithDeactivated') setWithDeactivated: any;
  @Getter('families/withDeactivated') withDeactivatedState: any;
  public get withDeactivated(): string {
    return this.withDeactivatedState;
  }

  public set withDeactivated(withDeactivated: string) {
    this.setWithDeactivated(withDeactivated);
  }

  @Action('families/setCity') setCity: any;
  @Getter('families/city') stateCity: any;

  public get city(): string {
    return this.stateCity;
  }

  public set city(city: string) {
    this.setCity(city);
  }

  @Action('families/setCurrentPage') setCurrentPage: any;
  @Getter('families/currentPage') currentPageState: any;
  public get currentPage(): number {
    return this.currentPageState;
  }

  public set currentPage(page: number) {
    this.setCurrentPage(page);
  }

  @Action('families/setItemsPerPage') setItemsPerPage: any;
  @Getter('families/itemsPerPage') itemsPerPageState: any;
  public get itemsPerPage(): number {
    return this.itemsPerPageState;
  }

  public set itemsPerPage(itemsPerPage: number) {
    this.setItemsPerPage(itemsPerPage);
  }

  @Action('families/fetchFamilies') fetchFamilies: any;
  @Getter('families/families') families: any;

  @Action('families/setFamiliesLoading') setFamiliesLoading: any;
  @Getter('families/familiesLoading') familiesLoadingState: any;

  public get familiesLoading(): boolean {
    return this.familiesLoadingState;
  }

  public set familiesLoading(value: boolean) {
    this.setFamiliesLoading(value);
  }

  @Getter('families/total') total: any;
  @Action('families/clearPayload') clearFilters: any;

  public async showFamily(family: Family) {
    this.familiesLoading = true;

    const dataRes = await axios.get(
      api.path('v1.admin.families.single', { id: family.id })
    );
    const balanceRes = await axios.get(
      api.path('v1.admin.families.balance', { id: family.id })
    );

    this.familyData = dataRes.data.data;
    this.familyData.balance = balanceRes.data.data;

    this.dialog = true;
    this.familiesLoading = false;
  }

  public editFamily(family: any) {
    this.$router.push({ name: 'edit-family', params: { id: family.id } });
  }

  @Getter('cities/cities') cities: any;
  @Action('cities/fetchCities') fetchCities: any;

  public async mounted() {
    this.fetchCities();
    await this.fetchFamilies();
  }
}
